import { useDownload } from 'hooks/ui/useDownload';
import { useState } from 'react';
import resourceExists from 'utils/resourceExists';

// This hook will try and download a PDF update for a specific investor & reporting ID.
// 1. It will see if the file exists in S3 at the provided pdfUrl using `resourceExists()`
// 2. If it does exist in S3, it will download it from there
// 3. If it doesn't exist in S3, it will call `investor-reporting/export-pdf-by-investor/...` which generates it on demand

export function useDownloadPdfUpdate(params) {
  const { reportingId, investorId, filename, pdfUrl } = params;

  const download = useDownload({
    filename,
    errorMessage: 'Investor update PDF could not be downloaded.',
  });
  const [loading, setLoading] = useState(false);

  const processDownload = async () => {
    if (!loading) {
      setLoading(true);
      // the signed url given above is only valid for getObject requests, hence a HEAD request
      // won't work. A more performant future solution would be to have an endpoint that returns
      // signed headObject urls OR ensure the get is properly cached for the subsequent download
      if (await resourceExists(pdfUrl, true)) {
        // file exists in s3 - take it from there
        download.mutate(pdfUrl);
      } else {
        // file is not in s3, perhaps it's still being generated or it was
        // never generated, so generate it on demand
        download.mutate(
          `investor-reporting/export-pdf-by-investor/${reportingId}/${investorId}`,
        );
      }
      setLoading(false);
    }
  };

  return { download: processDownload, loading: loading || download.isPending };
}
